<script setup>
import { ref } from 'vue'

const props = defineProps({
  // Async refresh action; the button shows a spinner until it resolves.
  action: {
    type: Function,
    required: true,
  },
})

const isLoading = ref(false)

const onRefresh = async () => {
  isLoading.value = true
  try {
    await props.action()
  } finally {
    isLoading.value = false
  }
}
</script>

<template>
  <q-btn
    icon="mdi-refresh"
    flat
    round
    dense
    size="sm"
    color="grey-9"
    :loading="isLoading"
    @click="onRefresh"
  />
</template>
